import { render, staticRenderFns } from "./ClaimForm.vue?vue&type=template&id=d432715c"
import script from "./ClaimForm.vue?vue&type=script&lang=js"
export * from "./ClaimForm.vue?vue&type=script&lang=js"
import style0 from "./ClaimForm.vue?vue&type=style&index=0&id=d432715c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports